import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../components/header.css";

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 50) {
        setIsHidden(true); // Hide navbar when scrolling down
      } else {
        setIsHidden(false); // Show navbar when scrolling up
      }

      setIsScrolled(currentScrollY > 50); // Add scrolled effect after 50px
      lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header
      className={`header ${isScrolled ? "scrolled" : ""} ${isHidden ? "hidden" : ""} ${location.pathname === "/" ? "homepage-nav" : ""}`}
    >
      <nav>
        <div className="logo">
          <Link
            to="/"
            className={`${location.pathname === "/" ? "homepage-nav" : ""}`}
          >
            Do&Be
            <p
              className={`travels-text ${location.pathname === "/" ? "homepage-nav" : ""}`}
            >
              Travels and Tours
            </p>
          </Link>
        </div>
        <button
          className={`hamburger ${isMenuOpen ? "active" : ""}`}
          onClick={toggleMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <ul className={`nav-links ${isMenuOpen ? "active" : ""}`}>
          <li>
            <Link
              to="/"
              className={`${location.pathname === "/" ? "homepage-nav" : ""} ${location.pathname === "/" ? "active" : ""}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/packages"
              className={`${location.pathname === "/" ? "homepage-nav" : ""} ${location.pathname === "/packages" ? "active" : ""}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Packages
            </Link>
          </li>
          <li>
            <Link
              to="/places"
              className={`${location.pathname === "/" ? "homepage-nav" : ""} ${location.pathname === "/places" ? "active" : ""}`}
              onClick={() => setIsMenuOpen(false)}
            >
              What we offer
            </Link>
          </li>
          <li>
            <Link
              to="/about"
              className={`${location.pathname === "/" ? "homepage-nav" : ""} ${location.pathname === "/about" ? "active" : ""}`}
              onClick={() => setIsMenuOpen(false)}
            >
              About Us
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
